module.exports = __webpack_public_path__ + "img/ion_location-outline.91e639dc.svg";